import {Accordion} from './Accordion'
(function() {
    const $accordions = document.querySelectorAll('.accordion')
    $accordions.forEach($a => new Accordion.AccordionToggler($a))

    const $accordionTriggers = document.querySelectorAll('.accordion-trigger')
    $accordionTriggers.forEach($a => new Accordion.AccordionToggler($a))

    const $accordionGrps = document.querySelectorAll('.accordion-group--carousel')
    $accordionGrps.forEach($a => new Accordion.AccordionGroup($a))
})()